import lodash from "lodash";

const TableOptionsEiendomDriftsform = ({
  index,
  handleChange,
  disabled
}: any): JSX.Element => {
  const capitalize = lodash.capitalize(index.driftsform);
  return (
    <div className="flex">
      <select
        className=" outline-none relative flex flex-grow justify-content
                                            py-2 text-lg border border-sk-primary-blue font-medium rounded-md
                                            text-black hover:border-blue-500 focus:ring-2 focus:ring-blue-600 text-justify md: "
        name="driftsform"
        title="driftsform"
        onChange={(e) => handleChange(e, index)}
        value={capitalize}
        disabled={disabled}
      >
        <option value="Velg et alternativ her...">
          Velg et alternativ her...
        </option>
        <option value="Aksjeselskap">Aksjeselskap</option>
        <option value="Stiftelse">Stiftelse</option>
        <option value="Eiet av sanitetsforeningen">
          Eiet av sanitetsforeningen
        </option>
        <option value="Annet">Annet</option>
      </select>
    </div>
  );
};
export default TableOptionsEiendomDriftsform;
